import {DefaultUrlSerializer, UrlSerializer, UrlTree} from '@angular/router';
import * as CryptoJS from 'crypto-js';

export class CustomUrlSerializer implements UrlSerializer {

    private static productionMode = true;
    private static ds = new DefaultUrlSerializer();
    private static key = "a93a732ec52853a7f98a6a3014f9a785f030f48a3594104fdd8c30b745d2f8ce";
    private static identifier = "/page/c/";

    public static decript(data: string): string {
        if (data.includes(CustomUrlSerializer.identifier) && CustomUrlSerializer.productionMode) {

            //desencriptar data
            data = data.replace(CustomUrlSerializer.identifier, "");
            try {
                data = CryptoJS.AES.decrypt(data, CustomUrlSerializer.key).toString(CryptoJS.enc.Utf8);
            } catch (err) {
            }

            return data;
        } else return data;
    }

    public static encript(data: string): string {
        data = CustomUrlSerializer.decript(data);
        //encriptar data
        if (CustomUrlSerializer.productionMode) {
            data = CustomUrlSerializer.identifier + CryptoJS.AES.encrypt(data, CustomUrlSerializer.key).toString();
        }
        return data;
    }

    parse(url: any): UrlTree {
        return CustomUrlSerializer.ds.parse(CustomUrlSerializer.decript(url));
    }

    serialize(tree: UrlTree): any {
        return CustomUrlSerializer.encript(CustomUrlSerializer.ds.serialize(tree));
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/modelo/UrlSerializer/custom-url-serializer.ts